import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight} from '@fortawesome/free-solid-svg-icons'
export default function JisAlert(props) {

  return (
    <div className={ "dialog-box open" }>
                    
                   
                        <div className="wrapper">
                        <h3>{props.title} </h3>
                        <div className="main">
                          
                            <p style={{marginTop:16, marginBottom:16, textAlign:'center'}}>{props.subtitle}</p>
                           
                            <div className="btns">
                                
                                <button className='red' onClick={props.onOk}>Ok <FontAwesomeIcon icon={faArrowRight} /></button>
                            </div>  
                        </div>
                    </div>
                    
                    
                </div>

  );
}
